import React, { useEffect, useRef, useState } from 'react'
import { useSelector , useDispatch} from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
// icons 
import {HiOutlineStatusOnline} from 'react-icons/hi'
import {AiOutlineAppstore , AiOutlineSetting} from 'react-icons/ai'
import {TbBarrierBlock } from 'react-icons/tb'
import {GiUpgrade} from 'react-icons/gi'
import {FiUsers} from 'react-icons/fi'
import {MdOutlinePayment} from 'react-icons/md'
import {BsArrowReturnRight} from 'react-icons/bs'
import {RiCompassDiscoverLine} from 'react-icons/ri'
import {VscSettings} from 'react-icons/vsc'
import { ReactComponent as Logo } from './../../assets/logo/logo.svg'

import './Sidebar.css'
import { NavLink } from 'react-router-dom';
import { isUUID } from '../../Helpers';
import { CustomSelect } from '../Select/Select';
import { updateOrganization, updateUserMemberships , updateUserOrganizations} from '../../Redux/features/authSlice';
import { updateGeneralUI } from '../../Redux/features/uiReducer';
import axios from 'axios';
import toast from 'react-hot-toast';


export function Sidebar() {

	let url_regex = /^(\/pages\/|\/o\/)([0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12})(.*)$/igm

	const navigate = useNavigate()
	const effectCalled = useRef(false)
 
	const [active, setActive] = useState("Status pages");
	const [subMenuActive, setSubMenuActive] = useState("Overview");
	const [opened, setOpened] = useState(false);
	const location = useLocation();
	
	let params = url_regex.exec(location?.pathname); url_regex.lastIndex = 0
	let _uuid = params!==null ? params[2] ?? null : null;
	const [selectedUUID, setSelectedUUID] = useState(( _uuid && isUUID(_uuid)) ? _uuid : null)


	// Grab the data from redux 
	const { user , org } = useSelector((state) => state.auth);
    const { general } = useSelector((state) => state.ui) 
	const dispatch = useDispatch();

 


	const data = [
		{ link: "/pages", label: "Status pages", icon: <HiOutlineStatusOnline /> , 
			subMenu : [
				{ link : `/pages/${selectedUUID}` ,            label : "Overview" ,      icon : <RiCompassDiscoverLine /> },
				{ link : `/pages/${selectedUUID}/incidents` ,  label : "Incidents" ,     icon : <TbBarrierBlock /> },
				{ link : `/pages/${selectedUUID}/components` , label : "Components" ,    icon : <AiOutlineAppstore /> },
				{ link : `/pages/${selectedUUID}/settings` ,   label : "Page settings" , icon : <AiOutlineSetting /> },
				{ link : `/pages/${selectedUUID}/billing` ,   label : "Upgrade" , icon : <GiUpgrade /> },
				// { link : '/subscribers' , label : "Subscribers" , icon : UserCircle },
				// { link : '/automations' , label : "Automation" , icon : DatabaseImport },
			] 
		},
		// { link: `/o/${org?.id}/automations`, label: "Automation", icon: <TbDatabaseImport /> , 
		//         subMenu : [
		//             { link : `/o/${org?.id}/automations/test1` ,   label : "Auto test 1" , icon : <RiCompassDiscoverLine /> },
		//             { link : `/o/${org?.id}/automations/test2` ,   label : "Auto test 2" , icon : <RiCompassDiscoverLine /> },  
					
		//         ]  },
		{ link: `/team`, label: "Team", icon: <FiUsers />  },
		{ link: `/billing`, label: "Billing", icon: <MdOutlinePayment /> },
		{ link: `/settings`, label: "Settings", icon: <VscSettings /> },
		 
	
	];
	
	useEffect(() => {
		let params = url_regex.exec(location?.pathname)
		url_regex.lastIndex = 0
		let _uuid = params!==null ? params[2] ?? null : null;
		setSelectedUUID(( _uuid && isUUID(_uuid)) ? _uuid : null )


		
		if(effectCalled.current) return ;

		//console.log('location?.pathname : ' , location?.pathname);
		
		// Select the active item on the root menu 
		const selectedMenuIndex = data.findIndex(x => x.link === location?.pathname );
		if(selectedMenuIndex >=0 ){
			setActive(data[selectedMenuIndex].label)
	  
		}else{
			//console.log('else ...');
			// May be it's a sub menu -> check !
			data.map( (rootItem , rootIndex) => {
				data[rootIndex]?.subMenu?.map( (subItem , subIndex) => {
					//console.log('location >>>> ' , location?.pathname , subItem?.link)
					if(location?.pathname.match(new RegExp(`^(\/${subItem?.link.substr(1)})([a-zA-Z0-9\-\_\/])*$` , `igm`) ) ){
					// if(location?.pathname === subItem?.link ) {

						setSubMenuActive(data[rootIndex]?.subMenu[subIndex]?.label)
						return 
					}
				})
			})
			 
		}
		
		



		effectCalled.current = true ;
	}, [location])

	/**
	 * UPDATE THE REDUX WITH THE SELECTED ORGANIZATION 
	 */
	const onChangeOrganization = async (e) => {

        const selectedOrgnizationId = e.value ;


        // Update the default organization for the current user 
        await updateDefaultOrgAPI(selectedOrgnizationId)
        .then(() => {
             // Update the redux : Mark the default organization
             let userMemberships = [...user?.memberships]
             let finalUserMembeships = userMemberships.map( item => {
                 if(item?.organization_id === selectedOrgnizationId) 
                 return {
                     ...item,
                     is_default : true
                 }
                 else
                     return {
                         ...item,
                         is_default : false
                     }
             })
             //console.log('finalUserMembeships : ' , finalUserMembeships)
             dispatch(updateUserMemberships(finalUserMembeships))
             // Update the redux : Mark the default organization for the memberships
             let userOrganizations = [...user?.organizations]
             let nextDefaultOrg = {}
             let finalUserOrganizations = userOrganizations.map( item => {
                 if(item?.id === selectedOrgnizationId) {   
                     nextDefaultOrg =  {
                         ...item,
                         is_default : true
                     } 
                     return nextDefaultOrg
                 }
                 else
                     return {
                         ...item,
                         is_default : false
                     }
             })
             //console.log('finalUserOrganizations : ' , finalUserOrganizations)
             dispatch(updateUserOrganizations(finalUserOrganizations))

             dispatch(updateOrganization(nextDefaultOrg))
        })
        .then(() => {
            navigate(0)
        })
        .catch(() => {

        })


	}

    const updateDefaultOrgAPI = async (selectedOrgnizationId) => {

        return new Promise( async (resolve , reject) => {

            if(user && user?.token ){
                const { token } = user 
    
                let params = {}
    
                await axios.put(`${process.env.REACT_APP_API_URL}/organizations/${selectedOrgnizationId}/default`, params , {
                    headers : {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,//'JWT token...'
                    }
                } )
                .then( res => res.data )
                .then( data => {
    
    
                   
                    resolve(data)
    
        
                })
                .catch(error => {
    
    
                    let __error = "Something went wrong. thank you try later.";
                    if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
                        navigate('/logout')
                    }
                     
                    if (error.response) {
                        if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
                        
                             
                        }
                        __error = ((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
                    } else {
                        // Something happened in setting up the request that triggered an Error
                        if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
                            __error = "Something went wrong. thank you try later.";
                        }
                    }
    
                    toast.error(__error)  

                    reject(__error)
                   
                })
            }
        })
    }



  	return (
		<div className={`sidebar ${general?.show_sidebar ? 'open' : ''}`}>			
			<div className="sidebar-content">
				<div className="sidebar-close"   >
					{/* <CloseMobileMenuIcon /> */}
				</div>
				<div className="logo">
					<Logo />
				</div>
				<div className="menu">
					<ul className="menu__list">
						{
							data.map( (menuItem , index) => {

							   return (
									<React.Fragment key={index}>
										<li  className="menu__list-item">
											<NavLink 
												exact={`true`} 
												// activeClassName='is-active' 
												// className="menu__link" 
												className={({ isActive }) => {
													const linkClasses = ["menu__link"];
													if (isActive) linkClasses.push('is-active');
													if (selectedUUID) linkClasses.push('has-parent-span');
													
													return linkClasses.join(" "); 
												}}
												to={menuItem?.link} 
                                                // onClick={() => dispatch(updateGeneralUI({ ...general , show_sidebar : false }))} 
                                                >
                                                    {
                                                        selectedUUID && menuItem?.subMenu?.length > 0 && 
                                                        location?.pathname.match(new RegExp(`^(\/${menuItem?.link.substr(1)})([a-zA-Z0-9\-\_\/])+$` , `igm`) ) 
                                                        ? <>
                                                            {menuItem?.icon}
                                                            {/* <span className='parent-item'>{menuItem?.label}</span>	 */}
                                                            <span>{org?.statuspages?.find(x => x.id === selectedUUID)?.name}</span>
                                                        </>
                                                        : <>
                                                        {menuItem?.icon}
                                                        <span>{menuItem?.label}</span>	
                                                        </>
                                                    }
											</NavLink>
										</li>
										{
											selectedUUID && menuItem?.subMenu?.length > 0 && 
											location?.pathname.match(new RegExp(`^(\/${menuItem?.link.substr(1)})([a-zA-Z0-9\-\_\/])+$` , `igm`) ) && 
							
											<li className="menu__list-item sub-items">
												
												{
													menuItem?.subMenu?.map( (subItem , subIndex) => (
							
														<div key={subIndex} className={`sub-item ${subItem?.label === subMenuActive ? 'active' : '' }`}>
															<BsArrowReturnRight />
															<NavLink
																
																className={({ isActive }) => {
																	const linkClasses = ["menu__link"];
																	if (isActive && subItem?.label === subMenuActive) linkClasses.push('is-active');
																	
																	return linkClasses.join(" "); 
																}}
																to={`${subItem.link}`}
																onClick={(event) => {
																	
																	setSubMenuActive(subItem.label);
                                                                    // dispatch(updateGeneralUI({ ...general , show_sidebar : false }));
																}}
																	>
																{subItem.icon}
																<span>{subItem.label}</span>
															</NavLink>
														</div>
													))
												}
											</li>
										}
									</React.Fragment>
								)
							})
						}
						{
							process.env.REACT_APP_LIVE_PAYMENT === 'false' &&
							<div className="test-mode_indice">TEST MODE</div>	
							
						}
					</ul>
				</div>
				<div className="sidebar-footer">
					<form>
						<CustomSelect 
							label="Organizations"
							data={user?.organizations?.map( item => ({ 
								value : item?.id , 
								label : item?.name,
							}))}
							placeholder="Organizations"
							nothingFound="Nothing found"
							onChange={ (e) => {
								onChangeOrganization(e)
							}}
							defaultValue={{
								value : user?.organizations?.find( x => x.is_default === true )?.id ,
								label : user?.organizations?.find( x => x.is_default === true )?.name,
							}}
							value={{
								value : org?.id,
								label : org?.name,
							}}
							className="fluid"
							menuPlacement="top"
							 
						/>
					</form>
				</div>
			</div>
		</div>
 	)
}
